import { observer } from 'mobx-react-lite';
import ExampleItem from '../example-item';
import exampleStore from '@/components/examples/store';

const ExampleList = observer(() => {
  return (
    <div className='flex justify-start flex-wrap gap-16px'>
      {
        exampleStore.data.dataList.map((item, index) => {
          return (
            <ExampleItem data={item}/>
          )
        })
      }
    </div>
  );
});

export default ExampleList;
